import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { IntakeQueueItem } from '@/types/api'

export function intakeQueryKey() {
  return ['intake'] as const
}

export function useIntakeQueue() {
  return useQuery({
    queryKey: intakeQueryKey(),
    queryFn: async () => {
      const data = await api.get<{ items: IntakeQueueItem[] } | IntakeQueueItem[]>('/intake')
      return Array.isArray(data) ? data : (data as { items: IntakeQueueItem[] }).items ?? []
    },
  })
}

export function useProcessIntakeItem() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, result }: { id: string; result?: string }) =>
      api.patch<IntakeQueueItem>(`/intake/${id}`, { status: 'done', result }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: intakeQueryKey() })
    },
  })
}
